// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__HzdmX","list":"BalanceDue_list__2hfjG","listRow":"BalanceDue_listRow__ZJ4Gg","total":"BalanceDue_total__NAptq"};